"use strict";
import { useIsAtomicBatchingSupportedByChainIdCallback } from "state/walletCapabilities/hooks/useIsAtomicBatchingSupportedByChain";
import { useWalletGetCapabilitiesMutation } from "state/walletCapabilities/hooks/useWalletGetCapabilitiesMutation";
import { isAtomicBatchingSupportedByChainId } from "state/walletCapabilities/lib/handleGetCapabilities";
import { useDelegationService } from "state/wallets/useDelegationService";
import { FeatureFlags } from "features/gating/flags";
import { useFeatureFlag } from "features/gating/hooks";
import { createHasMismatchUtil } from "features/smartWallet/mismatch/mismatch";
import { UniswapEventName } from "features/telemetry/constants";
import { sendAnalyticsEvent } from "features/telemetry/send.web";
import { getLogger } from "utilities/src/logger/logger";
import { useEvent } from "utilities/src/react/hooks";
export function useHasMismatchCallback() {
  const { mutateAsync } = useWalletGetCapabilitiesMutation();
  const getIsAtomicBatchingSupportedByChainId = useIsAtomicBatchingSupportedByChainIdCallback();
  const isWalletGetCapabilitiesDisabled = useIsWalletGetCapabilitiesDisabled();
  const delegationService = useDelegationService();
  const getIsAtomicBatchingSupported = async (input) => {
    if (isWalletGetCapabilitiesDisabled) {
      return false;
    }
    const isAtomicBatchingSupported = getIsAtomicBatchingSupportedByChainId(input.chainId);
    if (isAtomicBatchingSupported !== void 0) {
      return isAtomicBatchingSupported;
    }
    try {
      const result = await mutateAsync();
      if (result) {
        return isAtomicBatchingSupportedByChainId(result, input.chainId);
      }
      return false;
    } catch (error) {
      getLogger().error(error, {
        tags: {
          file: "useMismatchAccount.ts",
          function: "getIsAtomicBatchingSupported"
        }
      });
      return false;
    }
  };
  const onMismatchDetected = useEvent(
    (payload) => {
      sendAnalyticsEvent(UniswapEventName.SmartWalletMismatchDetected, {
        chainId: String(payload.chainId),
        delegatedAddress: payload.delegatedAddress
      });
    }
  );
  return useEvent(
    createHasMismatchUtil({
      logger: getLogger(),
      delegationService,
      getIsAtomicBatchingSupported,
      onMismatchDetected
    })
  );
}
export const useShowMismatchToast = () => {
  return useEvent(() => {
  });
};
function useIsWalletGetCapabilitiesDisabled() {
  return useFeatureFlag(FeatureFlags.ForceDisableWalletGetCapabilities);
}
